import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';

// apicore
import { APICore, setAuthorization } from 'src/helpers/api/apiCore';

// api
import { allImport as allImportApi } from './api';

// actions
import { importApiResponseSuccess, importApiResponseError } from './actions';

// constants
import { ImportactionTypes } from './constants';

type ImportData = {
    payload: any;
    type: string;
};

const api = new APICore();

/**
 * Add Import
 * @param {*} payload
 */
function* AllImport({ payload, type }: ImportData): SagaIterator {
    try {
        const response = yield call(allImportApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                importApiResponseSuccess(
                    ImportactionTypes.IMPORT_ALL,
                    data,
                    'Import has been created.',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while import!`;
            if (message) msg = message;
            yield put(importApiResponseSuccess(ImportactionTypes.IMPORT_ALL, data, msg, code, true, false));
        }
    } catch (error: any) {
        yield put(importApiResponseError(ImportactionTypes.IMPORT_ALL, [], error, 404, true, false));
    }
}

export function* watchGetImport() {
    yield takeEvery(ImportactionTypes.IMPORT_ALL, AllImport);
}

function* importSaga() {
    yield all([fork(watchGetImport)]);
}

export default importSaga;
